module.exports = __webpack_public_path__ + "img/pass_symbol.8fb300b8.svg";